import { BaseModel, PersonnelAppointment } from '@core/data-access';
import { Exclude, Expose } from 'class-transformer';
import { Default } from '@core/util';

@Exclude()
export class DirectorModel extends BaseModel {
  @Expose() name!: string;
  @Expose() nric?: string;
  @Expose() accountNumber?: string;
  @Expose() @Default([]) appointment!: PersonnelAppointment[];
}
